import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import {
  AnimalAlertPopover,
  AnimalAlertTriggerButton,
  closeAnimalAlertPopover,
  selectIsAnimalAlertPopoverOpen,
  toggleAnimalAlertPopover,
  useAnimalAlert,
} from '@/components/AnimalAlertButtons';
import { isPhone } from '@/helpers';
import { useSelector } from '@/redux/helper';
import { selectIsFreeUser } from '@/redux/selectors/users';

import RecordVideoButton from './RecordVideoButton';
import style from './style.scss';
import TakeSnapshotButton from './TakeSnapshotButton';
import ZoomBar from './ZoomBar';

const StreamControls = ({ position = 'left', isFullscreen = false, habitatId, cameraId }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsAnimalAlertPopoverOpen);
  const isFreeUser = useSelector(selectIsFreeUser);
  const { emitAnimalAlert, flaggedAlertType } = useAnimalAlert({
    habitatId,
    cameraId,
    entryPoint: 'habitat-stream',
  });

  return (
    <div className={clsx(style.streamControlsWrapper, style[position])}>
      <div className={style.streamControls}>
        <ZoomBar width="36px" height="190px" />

        {(!isPhone() || !isFullscreen) && (
          <>
            <div className="relative">
              <AnimalAlertTriggerButton onClick={() => dispatch(toggleAnimalAlertPopover())} />
              <AnimalAlertPopover
                open={isOpen && !isFreeUser}
                disabled={!!flaggedAlertType}
                habitatId={habitatId}
                className="absolute bottom-0 left-[60px]"
                onClose={() => dispatch(closeAnimalAlertPopover())}
                onSelect={emitAnimalAlert}
              />
            </div>
            <div className={style.snapshots}>
              <TakeSnapshotButton />
              <RecordVideoButton />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StreamControls;
